// extracted by mini-css-extract-plugin
export default {"actions":"XBm1yg9GjmWaz3veZfFA","summary":"_mIM4zsN0ujrG6F5RcyE"};